import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Using groups with go requires the latest version of `}<a parentName="p" {...{
        "href": "https://posthog.com/docs/integrate/server/go"
      }}>{`posthog-go`}</a>{`. Update dependencies via:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`go get -u github.com/posthog/posthog-go
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-go"
      }}>{`// Capturing an event with groups
client.Enqueue(posthog.Capture{
    DistinctId: "[distinct id]",
    Event:      "some event",
    Groups: posthog.NewGroups().
        Set("company", "id:5").
})

// Updating a groups properties
client.Enqueue(posthog.GroupIdentify{
    Type: "company",
    Key:  "id:5",
    Properties: posthog.NewProperties().
        Set("company_name", "Awesome Inc").
        Set("employees", 11),
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      